<template>
  <div
    v-if="disclaimer"
    class="callout container"
    :class="$blockClass(blockClass, 'callout-container')"
  >
    <div
      :class="$blockClass(blockClass, 'callout-wrapper')"
      class="callout__wrapper background-color background-color--background-lightbeige"
    >
      <span class="eyebrow-bullet" />
      <p
        class="body-2"
        v-html="$cleanRTE(disclaimer)"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Callout (callout)
 * -----------------------------------------------------------------------------
 * A callout message with a bullet.
 *
 * @param {String} disclaimer - The callout message
 */

export default {
  name: 'Callout',
  props: {
    blockClass: {
      type: String,
      default: '',
    },
    disclaimer: {
      type: String,
      default: '',
      required: true,
    },
  },

  data() {
    return {
      global: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>
